import { render, staticRenderFns } from "./AiAssistant.vue?vue&type=template&id=24e956e8&scoped=true"
import script from "./AiAssistant.vue?vue&type=script&lang=js"
export * from "./AiAssistant.vue?vue&type=script&lang=js"
import style0 from "./AiAssistant.vue?vue&type=style&index=0&id=24e956e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e956e8",
  null
  
)

export default component.exports